import { useInfiniteQuery } from "@tanstack/react-query"
import { getContentBySlug, getPostsNumber } from "../lib/wordpress"


export const useInfiniteContent = (type: string, perPage = 6, _embed = true) => {
  return useInfiniteQuery({
    queryKey: [type],
    queryFn: async ({ pageParam = 1 }) => {
      const [totalPosts, posts] = await Promise.all([
        getPostsNumber(type), 
        getContentBySlug(type, { page: pageParam, per_page: perPage, _embed: _embed })
      ])

      return { posts: Array.isArray(posts) ? posts : [], totalPosts }
    },
    getNextPageParam: (lastPage, allPages) => {
      const loadedPosts = allPages.reduce((acc, page) => acc + page.posts.length, 0)
      return loadedPosts < lastPage.totalPosts ? allPages.length + 1 : undefined 
    }
  })
}
